module.exports = __webpack_public_path__ + "static/6305-woodrose-17-4848b3ebc28658f63a5f5f17b0de1692.jpg";